'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const EMAIL_PROVIDERS = ['gmail.com', 'outlook.com', 'hotmail.com', 'uol.com.br', 'icloud.com'] as const;
interface EmailDomainAutocompleteProps {
  email: string;
  onSelect: (completedEmail: string) => void;
  visible?: boolean;
}
export function EmailDomainAutocomplete(t0) {
  const $ = _c(31);
  const {
    email,
    onSelect,
    visible: t1
  } = t0;
  const visible = t1 === undefined ? true : t1;
  const [open, setOpen] = useState(true);
  let atIndex;
  let hasAt;
  let t2;
  if ($[0] !== email) {
    atIndex = email.indexOf("@");
    hasAt = atIndex !== -1;
    t2 = hasAt ? email.slice(0, atIndex) : "";
    $[0] = email;
    $[1] = atIndex;
    $[2] = hasAt;
    $[3] = t2;
  } else {
    atIndex = $[1];
    hasAt = $[2];
    t2 = $[3];
  }
  const localPart = t2;
  let t3;
  if ($[4] !== atIndex || $[5] !== email || $[6] !== hasAt) {
    t3 = hasAt ? email.slice(atIndex + 1).toLowerCase() : "";
    $[4] = atIndex;
    $[5] = email;
    $[6] = hasAt;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const domainFragment = t3;
  let t4;
  bb0: {
    if (!hasAt || !localPart) {
      let t5;
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      t4 = t5;
      break bb0;
    }
    if (EMAIL_PROVIDERS.includes(domainFragment as (typeof EMAIL_PROVIDERS)[number])) {
      let t5;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      t4 = t5;
      break bb0;
    }
    let t5;
    if ($[10] !== domainFragment) {
      t5 = EMAIL_PROVIDERS.filter(provider => provider.startsWith(domainFragment));
      $[10] = domainFragment;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = t5;
  }
  const suggestions = t4;
  const hasSuggestions = visible && suggestions.length > 0;
  const showDropdown = hasSuggestions && open;
  let t5;
  if ($[12] !== localPart || $[13] !== onSelect) {
    t5 = provider_0 => {
      onSelect(`${localPart}@${provider_0}`);
    };
    $[12] = localPart;
    $[13] = onSelect;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleSelect = t5;
  if (!hasSuggestions) {
    return null;
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => {
      e.preventDefault();
      setOpen(_temp);
    };
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = open ? "Fechar sugest\xF5es" : "Abrir sugest\xF5es";
  const t8 = `size-5 transition-transform duration-200 ${showDropdown ? "rotate-180" : ""}`;
  let t9;
  if ($[16] !== t8) {
    t9 = <ChevronDown className={t8} />;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <button type="button" onMouseDown={t6} className="absolute top-1/2 right-4 -translate-y-1/2 text-muted-foreground hover:text-primary transition-colors z-10" aria-label={t7}>{t9}</button>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== handleSelect || $[22] !== localPart || $[23] !== showDropdown || $[24] !== suggestions) {
    t11 = showDropdown && <motion.div initial={{
      opacity: 0,
      y: -4
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -4
    }} transition={{
      duration: 0.15
    }} className="absolute left-0 right-0 top-full mt-1 overflow-hidden rounded-2xl border border-input bg-background shadow-lg z-20" role="listbox">{suggestions.map(provider_1 => <div key={provider_1} role="option" aria-selected={false}><button type="button" onMouseDown={e_0 => {
          e_0.preventDefault();
          handleSelect(provider_1);
        }} className="w-full text-left px-4 py-3 text-base text-muted-foreground hover:bg-accent hover:text-primary transition-colors"><span className="text-primary/70">{localPart}@</span><span className="font-medium text-primary">{provider_1}</span></button></div>)}</motion.div>;
    $[21] = handleSelect;
    $[22] = localPart;
    $[23] = showDropdown;
    $[24] = suggestions;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = <AnimatePresence>{t11}</AnimatePresence>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
function _temp(prev) {
  return !prev;
}